module.exports = __webpack_public_path__ + "img/meizu-2.1fec8916.png";